import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/i18n';
import { RenewalComponent } from './pages/renewal/renewal.component';

const routes: Routes = [
  { path: 'policy/:product/:id', component: RenewalComponent, data: { title: extract('Home') }, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class RenewalRoutingModule {}
